import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityOnIcon from '@material-ui/icons/Visibility';
import { getShopDetail } from '../../actions/Shop';
import { sendLogin } from '../../auth/Auth';
import ToggleLalapayEnableDialog from '../molecules/ToggleLalapayEnableDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  },
  buttonToggleUseReceipt: {
    whiteSpace: 'nowrap'
  }
};

const enhance = compose(
  connect(
    state => ({
      budgets: state.budgets.list,
      totalCount: state.budgets.count,
      offset: 1
    }),
    dispatch => ({
      actions: bindActionCreators({ getShopDetail }, dispatch)
    })
  ),
  withState('openChange', 'updateOpenChange', false),
  withState('openChangeConfirm', 'updateOpenChangeConfirm', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  })
);

const button = enhance(
  ({
    classes,
    actions,
    checkSession,
    openChange,
    updateOpenChange,
    params,
    onChangeToggleLalapayEnable,
    message,
    setMessage,
    openChangeConfirm,
    updateOpenChangeConfirm,
    setLalapayEnable,
    lalapayEnable,
    progress,
    shopName,
    setShopName,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    shopNameError,
    setShopNameError,
    bankNameError,
    setBankNameError,
    bankBranchNameError,
    setBankBranchNameError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    hasDetail,
    setHasDetail,
    onCloseDialog
  }) => {
    const cancelAction = () => updateOpenChange(false);
    const changeAction = paramChange => {
      console.log('paramChange', paramChange);
      const paramSubmit = {
        connectSystemId: params.connectSystemId,
        lalapayEnable: parseInt(lalapayEnable || params.lalapayEnable || 0, 10),
        editInput: paramChange.editInput,
        lalapayShopId: paramChange.lalapayShopId
      };
      updateOpenChange(false);
      updateOpenChangeConfirm(false);
      onChangeToggleLalapayEnable(paramSubmit);
    };

    const detailOpenAction = lalapayShopId => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      actions.getShopDetail(lalapayShopId).then(detailData => {
        checkSession(detailData);
        progress.updateOpenProgress(false);
        progress.updateLoading(false);
        setShopName(detailData.payload.shopName);
        if (
          typeof detailData.payload.bankAccount !== 'undefined' &&
          detailData.payload.bankAccount !== null
        ) {
          setBankName(detailData.payload.bankAccount.bankName);
          setBankBranchName(detailData.payload.bankAccount.bankBranchName);
          setBankAccountType(detailData.payload.bankAccount.bankAccountType);
          setBankAccountTypeStr(
            detailData.payload.bankAccount.bankAccountTypeStr
          );
          setBankAccountNumber(
            detailData.payload.bankAccount.bankAccountNumber
          );
          setBankAccountHolder(
            detailData.payload.bankAccount.bankAccountHolder
          );
        }
      });
    };

    const openDialogToggleLalapayEnable = () => {
      updateOpenChange(true);
      setLalapayEnable(lalapayEnable || params.lalapayEnable);
      if (params.lalapayEnable === 1 && params.lalapayShopId) {
        setHasDetail(true);
        detailOpenAction(params.lalapayShopId);
      }
    };

    return (
      <div>
        <Button
          color="primary"
          onClick={() => openDialogToggleLalapayEnable()}
          className={classes.buttonToggleUseReceipt}
        >
          {params.lalapayEnable ? (
            <>
              <VisibilityOnIcon className={classes.leftIcon} />
              利用する
            </>
          ) : (
            <>
              <VisibilityOffIcon className={classes.leftIcon} />
              利用しない
            </>
          )}
        </Button>
        <ToggleLalapayEnableDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          cancelAction={cancelAction}
          changeAction={changeAction}
          target="Change"
          lalapayEnable={lalapayEnable}
          setLalapayEnable={setLalapayEnable}
          params={params}
          message={message}
          setMessage={setMessage}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          progress={progress}
          detailOpenAction={detailOpenAction}
          shopName={shopName}
          setShopName={setShopName}
          bankName={bankName}
          setBankName={setBankName}
          bankBranchName={bankBranchName}
          setBankBranchName={setBankBranchName}
          bankAccountType={bankAccountType}
          setBankAccountType={setBankAccountType}
          bankAccountTypeStr={bankAccountTypeStr}
          setBankAccountTypeStr={setBankAccountTypeStr}
          bankAccountNumber={bankAccountNumber}
          setBankAccountNumber={setBankAccountNumber}
          bankAccountHolder={bankAccountHolder}
          setBankAccountHolder={setBankAccountHolder}
          shopNameError={shopNameError}
          setShopNameError={setShopNameError}
          bankNameError={bankNameError}
          setBankNameError={setBankNameError}
          bankBranchNameError={bankBranchNameError}
          setBankBranchNameError={setBankBranchNameError}
          bankAccountNumberError={bankAccountNumberError}
          setBankAccountNumberError={setBankAccountNumberError}
          bankAccountHolderError={bankAccountHolderError}
          setBankAccountHolderError={setBankAccountHolderError}
          setHasDetail={setHasDetail}
          hasDetail={hasDetail}
          onCloseDialog={onCloseDialog}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
